<template>
  <app-client-layout title="Information">
    <template #header>
      <h2 class="font-semibold text-xl text-gray-800 leading-tight">
        お知らせ一覧
      </h2>
    </template>
    <div
      v-if="!informationList.length">
      <p>
        現在、お知らせはありません。
      </p>
    </div>
    <div
      v-else
      class="m-6 items-center">
      <ul class="divide-y divide-gray-200 w-full max-w-5xl mx-auto">
        <li
          v-for="(information, i) in informationList"
          :key="i"
          class="bg-white divide-y divide-gray-200">
          <div
            class="cursor-pointer flex items-center p-4 md:p-6"
            @click="show(information)">
            <div class="text-sm text-gray-900 w-5">
              <span
                v-if="isUnread(information.id)"
                class="inline-block w-2 h-2 bg-red-500 rounded-full">
              </span>
            </div>
            <div class="block md:flex items-center flex-1">
              <div class="text-xs text-white bg-indigo-400 px-4 py-1 rounded-lg text-center inline md:text-sm md:mx-6 md:w-32 md:block">
                {{ informationCategories[information.category_id] }}
              </div>
              <span class="text-xs md:text-sm leading-5 text-gray-500 mx-2 md:mx-0">
                {{ formatDate(information.updated_at) }}
              </span>
              <div class="text-sm text-gray-900 flex-1 w-full my-2 md:my-0 md:mx-6">
                {{ information.subject }}
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </app-client-layout>
</template>

<script setup>
import moment from 'moment'
import {
  computed,
} from 'vue'
import { Inertia } from '@inertiajs/inertia'
import { usePage } from '@inertiajs/inertia-vue3'
import formatDate from '@/actions/format/date'
import AppClientLayout from '@/Layouts/AppClientLayout'

const props = defineProps({
  informationList: {
    type: Array,
    default: () => [],
  },
  readList: {
    type: Array,
    default: () => [],
  },
})

const informationCategories = computed(() => usePage().props.value.informationCategories)

const show = (information) => {
  Inertia.get(route('client-information.show', {
    client_information: information.id,
    information,
  }))
}

const isUnread = (id) => !props.readList.filter(information => information.information_id === id).length

</script>
